import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ISubscriptionPrices, ISubscriptionPricesState } from './interfaces';
import { getSubscriptionPrices } from './thunk';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

const initialState: ISubscriptionPricesState = {
  fetching: false,
  prices: undefined
};

const subscriptionPricesSlice = createSlice({
  name: 'subscriptionPrices',
  initialState,
  reducers: {},
  extraReducers: {
    [getSubscriptionPrices.pending.type]: (state): void => {
      if (!isFeatureEnabled(Features.PromotionalCodes)) {
        return;
      }
      state.fetching = true;
    },
    [getSubscriptionPrices.rejected.type]: (state): void => {
      if (!isFeatureEnabled(Features.PromotionalCodes)) {
        return;
      }
      state.fetching = false;
      state.prices = undefined;
    },
    [getSubscriptionPrices.fulfilled.type]: (state, action: PayloadAction<ISubscriptionPrices>): void => {
      if (!isFeatureEnabled(Features.PromotionalCodes)) {
        return;
      }
      state.fetching = false;
      state.prices = action.payload;
    }
  }
});

export const SubscriptionPricesReducer = subscriptionPricesSlice.reducer;